import styled from 'styled-components';

export default styled.h1`
  font-family: Gala, sans-serif;
  text-transform: uppercase;
  font-size: 30px;
  font-weight: 500;
  margin: 0 0 40px;
`;
